module.exports="precision highp float;\n#define GLSLIFY 1\nattribute vec2 position;\n\nvoid main() {\n  gl_Position = vec4(position, 1.0, 1.0);\n}";